import { createFileRoute } from "@tanstack/react-router";

import OAuthProvidersAdmin from "@/components/OAuthProvidersAdmin";

// Generated to match `src/app/admin/oauth-providers/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/oauth-providers")({
  component: OAuthProvidersAdmin,
});
